import React, { useState, useEffect } from "react";




export default function AutoPopup() {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => setOpen(false);

  return (
    <>
      {open && (
        <div className="popup-overlay">

          <div className="popup-box">

            {/* Close Icon */}
            <span className="popup-close" onClick={closePopup}>
              ×
            </span>

            <div className="popup-content">

             <iframe
      width="100%"
        height="315"
        src="https://www.youtube.com/embed/C25OW4lIqBs"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>

              <button className="popup-btn" onClick={closePopup}>
                Close
              </button>

            </div>

          </div>

        </div>
      )}
    </>
  );
}